
import "./applicantslist.css";
import { openDocumentsListDisplayModel } from "../../../store/slices/modalSlice";
import { useDispatch, useSelector } from "react-redux";
import DocumentsListDisplayModel from "../../documentsListDisplayModel/documentsListDisplayModel";
import { useState, useEffect } from "react";
import axiosInstance from "../../../api/axiosInstance";
import { mapApiApplicantToApplicant } from "../../Myorders/applicants/Applicants";

const ApplicantsList = () => {
  const dispatch = useDispatch();

  const [searchText, setSearchText] = useState("");
  const documentsListDisplayModel = useSelector(
    (state: { modal: { documentsListDisplayModel: boolean } }) =>
      state.modal.documentsListDisplayModel
  );
  const [applicants, setApplicants] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const applicantsPerPage = 10;
  const filteredApplicants = applicants.filter((app) => {
    const search = searchText.trim().toLowerCase();
    if (!search) return true;
    return (
      (app.name && app.name.toLowerCase().includes(search)) ||
      (app.applicant_Name && app.applicant_Name.toLowerCase().includes(search)) ||
      (app.unifiedNo && app.unifiedNo.toLowerCase().includes(search)) ||
      (app.Applicant_PassPort && app.Applicant_PassPort.toLowerCase().includes(search)) ||
      (app.Applicant_Country && app.Applicant_Country.toLowerCase().includes(search))
    );
  });
  const totalApplicants = filteredApplicants.length;
  const totalPages = Math.ceil(totalApplicants / applicantsPerPage);
  const startIdx = (currentPage - 1) * applicantsPerPage;
  const endIdx = startIdx + applicantsPerPage;
  const applicantsWithDocuments = filteredApplicants.filter((app: any) => app.documents && app.documents.length > 0);
  useEffect(() => {
    setCurrentPage(1);
  }, [searchText, applicants]);

  useEffect(() => {
    const fetchApplicants = async () => {
      setLoading(true);
      try {
        const response = await axiosInstance.get(
          "api/user/getAllApplicantList"
        );
        let apiApplicants = [];
        if (response.data && Array.isArray(response.data)) {
          apiApplicants = response.data;
        } else if (response.data && Array.isArray(response.data.applicants)) {
          apiApplicants = response.data.applicants;
        }
        if (apiApplicants.length > 0) {
          
          const mappedApplicants = apiApplicants.map(mapApiApplicantToApplicant);
          setApplicants(mappedApplicants);
        } else {
          setApplicants([]);
        }
      } catch (error) {
        setApplicants([]);
      } finally {
        setLoading(false);
      }
    };
    fetchApplicants();
  }, []);



  return (
    <>
      {" "}
      {/* Header */}
      {/* Personal Information */}
      <div className="row layout-border rounded-3">
        <div className="d-flex justify-content-between align-items-center mb-1 p-3 border-bottom py-2">
          <div>
            <h1 className="ff-semibold text-black mb-1 font-18">
              My Documents
            </h1>
            <p className="font-14 text-muted mb-0">Total {applicantsWithDocuments.length} Applicant </p>
          </div>
        </div>
        <div className="applicant-list  mt-3">
          <div className="row m-0">
            
            <div className="p-0 col table-search border rounded-3 d-flex align-items-center gap-2 m-3 up-form ps-2 d-block d-md">
              <div>
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 14 14"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M1 5.59587C1 6.24096 1.12071 6.87974 1.35523 7.47572C1.58975 8.07171 1.93349 8.61323 2.36683 9.06938C2.80018 9.52553 3.31462 9.88737 3.88081 10.1342C4.447 10.3811 5.05383 10.5082 5.66667 10.5082C6.2795 10.5082 6.88634 10.3811 7.45252 10.1342C8.01871 9.88737 8.53316 9.52553 8.9665 9.06938C9.39984 8.61323 9.74358 8.07171 9.97811 7.47572C10.2126 6.87974 10.3333 6.24096 10.3333 5.59587C10.3333 4.95078 10.2126 4.31201 9.97811 3.71603C9.74358 3.12004 9.39984 2.57852 8.9665 2.12237C8.53316 1.66622 8.01871 1.30438 7.45252 1.05752C6.88634 0.810654 6.2795 0.683594 5.66667 0.683594C5.05383 0.683594 4.447 0.810654 3.88081 1.05752C3.31462 1.30438 2.80018 1.66622 2.36683 2.12237C1.93349 2.57852 1.58975 3.12004 1.35523 3.71603C1.12071 4.31201 1 4.95078 1 5.59587Z"
                    stroke="#9B9B9B"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                  <path
                    d="M13 13.316L9 9.10547"
                    stroke="#9B9B9B"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  ></path>
                </svg>
              </div>
               <input
            type="text"
            className="form-control myorders-search p-0 border-0 rounded-0 mb-0"
            placeholder="Search Name, Passport No, Nationality"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
              
            </div>
            {/* <div className="col-md-6">
                      <div className="p-3 layout-border rounded-3 my-4">
                        {applicantDetails.map((item, index) => (
                          <div
                            className="d-flex gap-2 align-items-center mb-3"
                            key={index}
                          >
                            <div className="p-3 bg-3 rounded-circle">
                              <img
                                src={item.icon}
                                className="img-fluid"
                                alt=""
                                style={{ height: "25px", width: "25px" }}
                              />
                            </div>
                            <div
                              className={`flex-grow-1 pb-2 ${
                                index !== applicantDetails.length - 1
                                  ? "border-bottom"
                                  : ""
                              }`}
                            >
                              <p className="mb-1 font-12 text-black">
                                {item.label}
                              </p>
                              <p className="font-16 ff-semibold text-black mb-0">
                                {item.value}
                              </p>
                            </div>
                          </div>
                        ))}

                        <div className="visa-info-banner bg-beige text-noti font-11 p-2 px-2 my-2 ff-medium d-flex align-items-center justify-content-between gap-2 rounded-0">
                          <div className="d-flex align-items-center gap-1">
                            <svg
                              width="10"
                              height="10"
                              viewBox="0 0 10 10"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M4.99995 0.962891C5.43407 0.962891 5.83864 1.17518 6.08638 1.52974L6.13411 1.60248L9.82252 7.76104C9.93461 7.95517 9.9956 8.17458 9.99977 8.39872C10.0039 8.62286 9.95116 8.84438 9.84637 9.04256C9.74159 9.24074 9.58822 9.40908 9.40063 9.53182C9.21304 9.65456 8.99737 9.72768 8.77382 9.74434L8.68518 9.74798H1.30972C1.08594 9.74546 0.866439 9.68628 0.671715 9.57597C0.476991 9.46566 0.31339 9.30781 0.196184 9.11716C0.0789777 8.9265 0.0119871 8.70926 0.00146504 8.48571C-0.00905701 8.26216 0.0372326 8.03959 0.136013 7.83877L0.181016 7.75467L3.86761 1.60066C3.98564 1.40601 4.15185 1.24508 4.35019 1.13336C4.54853 1.02165 4.77231 0.962941 4.99995 0.962891ZM4.99995 5.20406H4.54537L4.49219 5.20724C4.38171 5.22038 4.27988 5.27359 4.206 5.35678C4.13211 5.43997 4.09131 5.54737 4.09131 5.65863C4.09131 5.7699 4.13211 5.8773 4.206 5.96049C4.27988 6.04368 4.38171 6.09688 4.49219 6.11003L4.54537 6.11321V7.47693L4.54856 7.53011C4.56052 7.63158 4.60632 7.72606 4.67857 7.79831C4.75082 7.87055 4.8453 7.91635 4.94676 7.92832L4.99995 7.9315H5.45452L5.50771 7.92832C5.60918 7.91635 5.70365 7.87055 5.7759 7.79831C5.84815 7.72606 5.89395 7.63158 5.90591 7.53011L5.9091 7.47693L5.90591 7.42374C5.89505 7.331 5.85588 7.24385 5.79374 7.17415C5.73161 7.10445 5.64951 7.05558 5.55862 7.03417L5.50771 7.02508L5.45452 7.02235V5.65863L5.45134 5.60545C5.43937 5.50398 5.39357 5.4095 5.32133 5.33726C5.24908 5.26501 5.1546 5.21921 5.05313 5.20724L4.99995 5.20406ZM5.00449 3.84034L4.94676 3.84352C4.83628 3.85666 4.73445 3.90987 4.66057 3.99306C4.58669 4.07625 4.54588 4.18365 4.54588 4.29491C4.54588 4.40618 4.58669 4.51357 4.66057 4.59677C4.73445 4.67996 4.83628 4.73316 4.94676 4.7463L4.99995 4.74949L5.05768 4.7463C5.16816 4.73316 5.26999 4.67996 5.34387 4.59677C5.41776 4.51357 5.45856 4.40618 5.45856 4.29491C5.45856 4.18365 5.41776 4.07625 5.34387 3.99306C5.26999 3.90987 5.16816 3.85666 5.05768 3.84352L5.00449 3.84034Z"
                                fill="#CF770C"
                              />
                            </svg>

                            <span>
                              Download documents by click on view document
                            </span>
                          </div>
                        </div>
                      </div>
                    </div> */}
            <section className="documents-all-list ">
               
              <div className="row ">
                <h6 className="ff-semibold text-black  mb-2 frm-hd">
                  Applicants
                </h6>
                {loading ? (
                  <div className="text-center py-5">Loading applicants...</div>
                ) : filteredApplicants.length === 0 ? (
                  <div className="text-center py-5">No applicants found.</div>
                ) : (
                  applicantsWithDocuments
                    .slice(startIdx, endIdx)
                    .map((app: any, index: any) => (
                    <div className="col-md-4 my-3" key={index}>
                      <div className="doc-wallet-container position-relative text-white rounded-3 overflow-hidden">
                        {/* Top info bar */}
                        <div className="doc-wallet-header d-flex align-items-center justify-content-start px-2 pt-2 position-absolute w-100">
                        <span
                                className={`rounded-circle flag-icon flag-icon-${
                                  app?.Applicant_Country
                                      ? app.Applicant_Country.toLowerCase()
                                    : "ae"
                                } me-1`}  style={{width: "20px", height: "20px"}}></span>
                                  <span className="doc-wallet-name">{app.name || app.applicant_Name}</span>  &nbsp; 
                          <span className="doc-wallet-name">{app.unifiedNo || app.Applicant_PassPort}</span>
                        </div>
                        {/* Wallet Image */}
                        <img
                          src="https://goodhand.b-cdn.net/Assets/Upload/wallet-empty1.svg"
                          className="img-fluid w-100"
                          alt="wallet"
                        />
                     
                        <div className="doc-wallet-btn-wrapper position-absolute w-100 text-center">
                          <button
                            className="btn btn-outline-light doc-wallet-btn"
                            onClick={() => {
                              const documentsToPass = app.documents && app.documents.length > 0 
                                ? app.documents 
                                : [
                                    {
                                      applicantName: app.name || app.applicant_Name || "Test Applicant",
                                      storedName: "test_document.jpg",
                                      originalName: "test_document.jpg",
                                      label: "Test Document",
                                      RecordId: 1
                                    }
                                  ];
                              
                              dispatch(openDocumentsListDisplayModel(documentsToPass));
                            }}
                          >
                            View documents
                          </button>
                        </div>
                      </div>
                    </div>
                  ))
                )}
              </div>
              
            </section>
            
          </div>
          
        </div>
            <nav className="d-flex justify-content-center mt-4">
          <ul className="pagination custom-pagination1">
            {/* Previous button */}
            <li className={`page-item${currentPage === 1 ? " disabled" : ""}`}>
              <button
                className="page-link rounded-circle"
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
                aria-label="Previous"
              >
                <svg
                  width="8"
                  height="12"
                  viewBox="0 0 8 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6.5 0.785156L1.5 5.78516L6.5 10.7852"
                    stroke="#9A9A9A"
                    strokeWidth="1.25"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </button>
            </li>
            {/* Page numbers */}
            {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
              <li
                key={page}
                className={`page-item${currentPage === page ? " active" : ""}`}
              >
                <button
                  className="page-link rounded-circle"
                  onClick={() => setCurrentPage(page)}
                  disabled={currentPage === page}
                >
                  {page}
                </button>
              </li>
            ))}
            {/* Next button */}
            <li className={`page-item${currentPage === totalPages || totalPages === 0 ? " disabled" : ""}`}>
              <button
                className="page-link rounded-circle"
                onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                disabled={currentPage === totalPages || totalPages === 0}
                aria-label="Next"
              >
                <svg
                  width="16"
                  height="16"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                >
                  <path
                    d="M5 1l8 7-8 7"
                    stroke="currentColor"
                    strokeWidth="2"
                    fill="none"
                  />
                </svg>
              </button>
            </li>
          </ul>
        </nav>
      </div>
      
      {documentsListDisplayModel && <DocumentsListDisplayModel />}
    </>
  );
};

export default ApplicantsList;
